import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const otherServicesApi = createApi({
  reducerPath: "adminOtherServices",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["adminOtherServices"],
  endpoints: (builder) => ({
    getOtherServices: builder.query({
      query: () => ({
        url: `admin/otherservices/list`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { startRow: 0, endRow: 10 },
      }),
      providesTags: ["adminOtherServices"],
    }),
    createService: builder.mutation({
      query: (service) => ({
        url: `/admin/otherservices`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
      invalidatesTags: ["adminOtherServices"],
    }),
    removeService: builder.mutation({
      query: ({ Id }) => ({
        url: `/admin/otherservices/${Id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { Id },
      }),
      invalidatesTags: ["adminOtherServices"],
    }),
    editService: builder.mutation({
      query: (service) => ({
        url: `/admin/otherservices/${service.id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
      invalidatesTags: ["adminOtherServices"],
    }),
    getUploadURL: builder.query({
      query: () => ({
        url: "admin/otherservices/getuploadurl",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const {
  useGetOtherServicesQuery,
  useCreateServiceMutation,
  useRemoveServiceMutation,
  useEditServiceMutation,
  useGetUploadURLQuery,
} = otherServicesApi;
